import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "gfu-heading gfu-heading--top-divider _mt-3 _mb-2",
  "data-qa": "digital-content-header"
}
const _hoisted_2 = { class: "_mb-4" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_digital_content_section_item = _resolveComponent("digital-content-section-item")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.Resources.YourPledge.DigitalContentSectionHeader), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.Resources.YourPledge.DigitalContentSectionDescription), 1 /* TEXT */),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.items, (item) => {
      return (_openBlock(), _createBlock(_component_digital_content_section_item, {
        key: item.orderItemID,
        item: item,
        "data-qa": `digital-content-section:${item.orderItemID}`
      }, null, 8 /* PROPS */, ["item", "data-qa"]))
    }), 128 /* KEYED_FRAGMENT */))
  ], 64 /* STABLE_FRAGMENT */))
}